module.exports = __webpack_public_path__ + "static/media/dash-complete-icon.6e68e5fd.svg";